import Modal, { ModalProps } from './Modal';
import Spinner from './Spinner';
import React, { FC, useRef } from 'react';
import styled from 'styled-components';

const Iframe = styled.iframe<{ hide: boolean }>`
  ${({ hide }) => hide && `display: none;`}
`;

const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
`;

interface IframeModalProps extends ModalProps {
  name: string;
  hideContent?: boolean;
  zIndex?: string;
}

const IframeModal: FC<IframeModalProps> = ({
  name,
  hideContent,
  zIndex,
  ...props
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  return (
    <Modal {...props} zIndex={zIndex || '100'}>
      <Iframe ref={iframeRef} title="팝업" name={name} hide={!!hideContent} />
      {hideContent && (
        <SpinnerContainer>
          <Spinner style={{ marginRight: '5px' }} /> Loading...
        </SpinnerContainer>
      )}
    </Modal>
  );
};

export default IframeModal;
